<template>
    <div>
        <base-header class="pb-6" type="">
            <b-row class="align-items-center py-4">
                <b-col lg="12" cols="12">
                    <!-- <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6> -->
                    <h6 class="h2 d-inline-block mb-0">{{language_terms[$route.name]}}</h6>
                    <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                    <route-breadcrumb/>
                    </nav>
                </b-col>
            </b-row>
        </base-header>
        <b-container fluid class="mt--6">
            <div>
                <loading :active.sync="loading" 
                    color= '#007bff'
                    :width= '128'
                    :height= '128'
                    loader='dots'
                    :can-cancel="true" 
                    :is-full-page="true">
                </loading>
            </div>
            <b-row>
                <b-col cols="12">
                    <b-card>
                        <div slot="header" class="mb-0">
                            <b-row>
                                <b-col cols="10">
                                    <h3>{{title}}</h3>
                                </b-col>
                            </b-row>
                        </div>
                        <b-row>
                            <b-col  cols="12" md="6">
                                <base-input :label="language_terms['CODE']" v-model="product_category.code" :disabled="!is_edit"></base-input>
                            </b-col>
                            <b-col cols="12" md="6">
                                <base-input :label="language_terms['NAME']" v-model="product_category.name" :disabled="!is_edit"></base-input>
                            </b-col>
                        </b-row>
                        <b-row class="mt-2">
                            <b-col cols="12" md="3">
                                <b-form-checkbox class="mb-3 ml-4" v-model="product_category.is_active" value="1" unchecked-value="0" :disabled="!is_edit" switch>
                                    {{language_terms['IS_ACTIVE']}}
                                </b-form-checkbox>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>
            </b-row>
            <div class="floating-bar">
                <div class="floating-bar-container" align="center">
                    <b-button-group>
                        <b-button class="transparent-btn"  @click="clickOnedit" v-if="!is_edit">
                            <i class="fas fa-edit mr-2 text-primary"></i>{{language_terms['EDIT']}}
                        </b-button>
                        <b-button class="transparent-btn"  @click="save" v-if="is_edit">
                            <i class="fas fa-save mr-2 text-info"></i>{{language_terms['SAVE']}}
                        </b-button>
                        <b-button class="transparent-btn"  @click="cancel" v-if="is_edit">
                            <i class="fas fa-times mr-2 text-warning"></i>{{language_terms['CANCEL']}}
                        </b-button>
                        <b-button class="transparent-btn" v-if="$route.params.id != '_new'"  @click="deleteData">
                            <i class="fas fa-trash mr-2 text-danger"></i>{{language_terms['DELETE']}}
                        </b-button>
                        <b-button class="transparent-btn"  @click="clickOnBack">
                            <i class="fas fa-arrow-left mr-2 text-success"></i>{{language_terms['BACK']}}
                        </b-button>
                    </b-button-group>
                </div>
            </div>
        </b-container>

    </div>
</template>
<script>
import { mapState } from 'vuex';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';  

export default
{
    computed:{
        ...mapState({
            language_terms: state => state.languages.language_terms,
            is_created: state => state.productCategories.is_created,
            is_updated: state => state.productCategories.is_updated,
            is_deleted: state => state.productCategories.is_deleted,
            product_categories: (state) => state.productCategories.product_categories,
            product_category_filter: (state) => state.productCategories.filter,
            product_category_data: (state) => state.productCategories.data
        })
    },
    components:{
        Loading
    },
    data(){
        return{
            loading:false,
            title:"",
            is_edit:false,
            product_category:{
                code:"",
                name:"",
                is_active:"1",
                is_customer:"0",
                is_vendor:"0",
                is_employee:"0"
            }
        }
    },
    async mounted()
    {
        let id = this.$route.params.id

        if(id == '_new')
        {
            this.title = this.language_terms['NEW_PRODUCT_CATEGORY']
            this.is_edit = true
        }
        else
        {
            await this.$store.dispatch("productCategories/fetch", {code:id});
            this.product_category = this.product_category_data
            this.title = this.product_category.code
        }

    },
    methods:{
        clickOnedit()
        {
            this.is_edit = true
        },
        async deleteData()
        {
            await this.$store.dispatch("productCategories/delete", this.product_category);
            if(this.is_deleted)
            {
                await this.search()
                this.$router.push("/settings/product-categories")
            }
        },
        async save()
        {
            this.loading = true
            if(this.$route.params.id == '_new')
            {
                await this.$store.dispatch("productCategories/create", this.product_category);
                if(this.is_created)
                {
                    await this.search()
                    this.$router.push("/settings/product-categories")
                }
            }
            else
            {
                await this.$store.dispatch("productCategories/update", this.product_category);
                if(this.is_updated)
                {
                    await this.search()
                    this.$router.push("/settings/product-categories")
                }
            }

            this.loading = false

        },
        async search()
        {
            this.loading = true
            let filter = {keyword:"",active_only:"1"}
            if(this.product_category_filter)
            {
                filter = this.product_category_filter
            }
            await this.$store.dispatch('productCategories/quickSearch', filter)

            this.loading = false
        },
        clickOnBack()
        {
            this.$router.push("/settings/product-categories")
        },
        async cancel()
        {
            if(this.$route.params.id == '_new')
            {
                this.$router.push("/settings/product-categories")
            }
            else
            {
                location.reload();
            }    
        }
    }
}

</script>